export default __webpack_public_path__ + "static/media/buy.a8ee1783.svg";